const { __ } = wp.i18n;

function EntidadesItem({ id, title, logo, external_link }) {

  return (
    <a href={`${external_link}`} key={title} className={`item item-logo-${id} item-logo has-card-white-500-background-color`} target="_blank" rel="nofollow">
      {logo && <img src={logo} alt={title} className="inner-logo" loading="lazy" />}
      <span className="item-cta">
        <span className="wp-button is-underlined has-text-black-500-color">
          { __('Activar Bizum', 'bizum-website') }
          <img src={`${scriptsData.themeUrl}/assets/images/icons-default/arrow-up-right.svg`} alt="Activar Bizum" className="icon-arrow-right" />
        </span>
      </span>
    </a>
  )
  
}

export default EntidadesItem;